import { html } from "lit";
var icon_forward_default = () => html`
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="-3 -3 32 32">
    <path
      d="M13.196.897l.084.073 10.5 10.5a.754.754 0 01.092.11l.054.095.035.086.027.103.01.084v.103l-.018.12-.019.068-.023.06-.035.07-.06.09-.063.071-10.5 10.5a.75.75 0 01-1.133-.976l.073-.084 9.219-9.22H.75a.75.75 0 01-.102-1.493l.102-.007h20.689l-9.22-9.22a.75.75 0 01-.072-.976L12.22.97a.75.75 0 01.874-.137l.102.064z" />
  </svg>
`;
export {
  icon_forward_default as default
};
//# sourceMappingURL=icon-forward.js.map
